import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { ClientFilters } from "./clientFilters";
import { listCustomerSummaries } from "./customerSummariesApi";

export const useCustomerSummaries = (filters: ClientFilters) => {
  const { data, isFetching } = useQuery({
    queryKey: ["customers", "summaries", filters],
    queryFn: ({ signal }) => listCustomerSummaries(filters, signal),
    placeholderData: keepPreviousData,
  });
  return { summaries: data ?? [], isFetching };
};
